// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles_checkboxWrapper__+cZlm","checkboxLabel":"styles_checkboxLabel__OiNAx","checkbox":"styles_checkbox__BmAJU"};